/*
 * Next script
 * The script initializes the App; the intention of this file is to use the advantages of rollup (using files with
 * appended hash value for caching purposes) and to include the file in the HTML body with the last modified
 * time stamp (also for caching purposes)
 *
 * If you are using several translation files, just import the translations and apply it to the parameter 'translations'
 * of the App configuration
 *
 */

// import style definitions for rollup (necessary!)
import '../css/glads.scss';

// include translation files
import languageSparkDE from "spark-web/source/ui/js/i18n/de";
import languageNextDE from './i18n/de';

// include polyfill
import '@ungap/custom-elements/min'

// import app, initialize app and import elements
import('spark-web/source/ui/js/app').then((spark) => {
	return spark.App.initialize({
		translations: [languageSparkDE, languageNextDE]
	});
}).then(() => {
	// import own elements
	import('./elements');
});

